import React from "react";

export default function HomeLandingHero({
  heroBgSrc,
  heroTextTitle,
  heroTextSubtitle,
}: {
  heroBgSrc: string;
  heroTextTitle: string;
  heroTextSubtitle: string;
}) {
  return (
    <section
      className="homeLandingHero"
     
    >
      <img className="homeLandingHeroBg" src="/images/icons/hero-image.jpg" alt="hero-image" />
      <div className="homeLandingHeroInner">
        <h1 className="homeLandingHeroTitle">{heroTextTitle}</h1>
        <p className="homeLandingHeroSubtitle">{heroTextSubtitle}</p>
      </div>
    </section>
  );
}

